import { render, staticRenderFns } from "./ResidentAutoPaymentWidget.vue?vue&type=template&id=52629336&scoped=true&"
import script from "./ResidentAutoPaymentWidget.vue?vue&type=script&lang=ts&"
export * from "./ResidentAutoPaymentWidget.vue?vue&type=script&lang=ts&"
import style0 from "./ResidentAutoPaymentWidget.vue?vue&type=style&index=0&id=52629336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52629336",
  null
  
)

export default component.exports